export default function Style(){
  return (
    <style>
      {`
       .usecase_para{
    color: #5e5e5e;
    font-family:'Josefin Sans';
    
}
        `}
    </style>
  );
}
